<template>
  <div id="app">
    <transition name="fade" v-if="isRouterAlive" mode="out-in">
			<router-view></router-view>
		</transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
 @import '/components/css/main.css';
#app {
  -webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	 font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
</style>


<script>
export default {
	name:'app',
	provide(){
		return{
			reload:this.reload,
			goPath:this.goPath
		}
	},
	data(){
		return{
			isRouterAlive:true,
		}
	},
	methods:{
		reload(){
			this.isRouterAlive=false;
			this.$nextTick(function(){
				this.isRouterAlive=true;
			})
		},
		goPath(path){
			if(path){
				this.$router.push(path);
			}
		}
	},
	destroyed(){
		sessionStorage.clear();
		localStorage.clear();
	}
}
</script>



// WEBPACK FOOTER //
// src/App.vue